let assetsPath: string = "";

document.addEventListener("uxThemeChange", () => (assetsPath = ""));

export const getAssetsPath = (): string => {
    if (assetsPath === "") {
        calculateAssetsPath();
    }
    return assetsPath;
};

const calculateAssetsPath = () => {
    const dummyElement = document.createElement("div");
    dummyElement.className = "ux-icon__svg-path-detector";
    const firstIcon = document.querySelector("ux-icon");
    if (firstIcon === null) return;
    firstIcon.insertAdjacentElement("afterend", dummyElement);
    assetsPath = getComputedStyle(dummyElement)
        .backgroundImage.replace(`url("`, "")
        .replace(/[a-zA-Z0-9_.]*"\)$/, "");
    dummyElement.remove();
};
